import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';

const CLOSED = 'CLOSED' as const;
const SHOWING_ISSUE = 'SHOWING_ISSUE' as const;
const SHOWING_CONFIGURATION = 'SHOWING_CONFIGURATION' as const;
const SHOWING_INSIGHTS = 'SHOWING_INSIGHTS' as const;

export const SidebarStatuses = {
	CLOSED,
	SHOWING_ISSUE,
	SHOWING_CONFIGURATION,
	SHOWING_INSIGHTS,
} as const;

type Closed = {
	status: typeof CLOSED;
};

type ShowingIssue = {
	status: typeof SHOWING_ISSUE;
	issueKey: IssueKey;
};

type ShowingConfiguration = {
	status: typeof SHOWING_CONFIGURATION;
};

type ShowingInsights = {
	status: typeof SHOWING_INSIGHTS;
};

export type SidebarState = Closed | ShowingIssue | ShowingConfiguration | ShowingInsights;
export type SidebarStoreState = {
	state: SidebarState;
};
